import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux"
import { ENDPOINT_PATH } from "../../../../config/paths";
import { postEndpoint } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from "../../../layout/Content";
import EndpointForm from "./EndpointForm";
import { DEFAULT_ENDPOINT_PERMISSION_TYPE_OPTION } from "../../../../config/defaults";

export const NewEndpoint = ({ breadcrumbs, dispatchPostEndpoint }) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };
    newFormValues.permissionType =
      formValues.permissionType && formValues.permissionType.value;

    dispatchPostEndpoint(newFormValues);
  };

  const content = (
    <EndpointForm
      onSubmit={onSubmit}
      initialValues={{
        permissionType: DEFAULT_ENDPOINT_PERMISSION_TYPE_OPTION,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Punto de Acceso"
      subtitle="Crear nuevo punto de acceso"
      content={content}
    />
  );
};

NewEndpoint.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostEndoint: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostEndpoint: postEndpoint,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Puntos de Acceso',
      href: ENDPOINT_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewEndpoint)